/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Available_FromInputs */

const cs_form_available_from = /** @type {(inputs: Form_Available_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volné od`)
};

const en_form_available_from = /** @type {(inputs: Form_Available_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available from`)
};

/**
* | output |
* | --- |
* | "Available from" |
*
* @param {Form_Available_FromInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_available_from = /** @type {((inputs?: Form_Available_FromInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Available_FromInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_available_from(inputs)
	return cs_form_available_from(inputs)
});